import { ICommunicationTypeResult } from "@/interfaces/ICommunicationTypeResult";
import { ICommunicationSubCategory } from "@/interfaces/ICommunicationSubCategory";

export default class CommunicationCategory{
    constructor(idCategory?: string, name?:string,typeId?:string,typeName?: string, communicationSubCategories?: Array<ICommunicationSubCategory>,communicationType?:ICommunicationTypeResult){
    (idCategory) ? this.idCategory = idCategory : this.idCategory = "";
    (name) ? this.name = name : this.name = "";
    (typeId) ? this.typeId = typeId : this.typeId = "";
    (typeName) ? this.typeName = typeName : this.typeName = "";
    (communicationSubCategories) ? this.communicationSubCategories = communicationSubCategories : this.communicationSubCategories = Array<ICommunicationSubCategory>();
    (communicationType) ? this.communicationType = communicationType : this.communicationType = 
    {
        id:"",name:"",mustHaveLink:false,mustHaveText:false,mustHaveTitle:false,canHaveAttachments:false,canHaveLink:false,canHaveText:false,canHaveTitle:false,isActiveReadingConfirmation:false
    }
}
    public idCategory: string;
    public name: string;
    public typeId: string;
    public typeName : string;
    public communicationSubCategories: Array<ICommunicationSubCategory>;
    public communicationType: ICommunicationTypeResult;
}